import { render, staticRenderFns } from "./ModalSDP.vue?vue&type=template&id=6033b5cb"
import script from "./ModalSDP.vue?vue&type=script&lang=js"
export * from "./ModalSDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports